import RepositoryService from 'src/services/repository'

const resource = 'networkDiagram/session'

export default RepositoryService.utils.createCrudRepository(resource)
